"use strict";
var ForkJoinObservable_1 = require('./ForkJoinObservable');
exports.forkJoin = ForkJoinObservable_1.ForkJoinObservable.create;
//# sourceMappingURL=forkJoin.js.map


//////////////////
// WEBPACK FOOTER
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/rxjs/observable/forkJoin.js
// module id = 87
// module chunks = 0 1 2 3 4 6